import { combineReducers } from "redux";
import { app } from '@/store/reducers/app.reducer';
import { data } from '@/store/reducers/data.reducer';
import { auth } from '@/store/reducers/auth.reducer';
import { alert } from '@/store/reducers/alert.reducer';

export default combineReducers({
	app, data, auth, alert,
});
